<template>
  <detail-page>
    <template #title>
      <div class="title"></div>
    </template>
    <template #content>
      <tab-list />
    </template>
  </detail-page>
</template>

<script>
import DetailPage from '@/views/mobile/components/detailPage/Index.vue'
import TabList from './components/TabList.vue'

export default {
  name: 'MobileList',
  components: {
    DetailPage,
    TabList,
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: 3.866666vw;
  width: 100%;
  height: 23.2vw;
  background: url('~@/assets/img/mobile/title.png') no-repeat;
  background-size: 100%;
  background-position: center 0;
}
</style>